import { isArticleGroup } from '@common/article-catalog';
import { rootTagOf } from '@rt-tools/cms-angular/site';

import type { IBlogArticle } from './blog-article.types';
import { BLOG_GROUP_LABELS } from './blog-group-labels.const';

// Рубрика статьи — корневой тег её первого тега. Тег с именем прежней группы блога подписан
// переводом группы, остальные — своим именем. Без тегов рубрики нет — `null`.
export function blogRubricOf(article: IBlogArticle.State, tags: readonly IBlogArticle.Tag[]): string | null {
    const tag: IBlogArticle.Tag | null = rootTagOf(article, tags);
    if (tag === null) {
        return null;
    }
    return isArticleGroup(tag.name) ? BLOG_GROUP_LABELS[tag.name] : tag.name;
}

// Карточки статей с подписями рубрик — для списка блога, карусели главной и похожих статей.
export function blogCardsOf(articles: readonly IBlogArticle.State[], tags: readonly IBlogArticle.Tag[]): IBlogArticle.Card[] {
    return articles.map((article: IBlogArticle.State) => ({ article, rubric: blogRubricOf(article, tags) ?? '' }));
}
